import { Component } from 'react';
import { Card, CardContent, CardHeader } from '@heroui/react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error.toString() };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      errorInfo: errorInfo.componentStack
    });
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card className="bg-danger/10 border border-danger/30 m-6 max-w-xl mx-auto">
          <CardContent className="gap-4 p-6">
            <div className="flex items-start gap-4">
              <div className="flex-1">
                <h2 className="text-lg font-semibold text-danger mb-2">
                  {this.props.message || 'Something went wrong'}
                </h2>
                <p className="text-sm text-default-600 mb-4">
                  Please contact development support if the problem persists.
                </p>
                
                {process.env.NODE_ENV === 'development' && (
                  <details className="text-xs bg-default-100 p-3 rounded-lg mt-4">
                    <summary className="cursor-pointer font-semibold text-default-700 mb-2">
                      Error Details
                    </summary>
                    <div className="space-y-2">
                      {this.state.error && (
                        <div>
                          <span className="font-mono text-danger">
                            {this.state.error}
                          </span>
                        </div>
                      )}
                      {this.state.errorInfo && (
                        <div className="mt-2 text-default-600">
                          <pre className="whitespace-pre-wrap text-xs overflow-auto max-h-48">
                            {this.state.errorInfo}
                          </pre>
                        </div>
                      )}
                    </div>
                  </details>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      );
    }
    return this.props.children; 
  }
}

export default ErrorBoundary;